
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'partly-cloudy-night': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M69.763 46.758a11.936 11.936 0 0 1 2.179 6.883c0 6.625-5.371 11.998-11.998 11.998H43.946c-8.836 0-15.998-7.162-15.998-15.998s7.162-15.998 15.998-15.998c2.002 0 3.914.375 5.68 1.047 1.635-4.682 6.078-8.047 11.318-8.047.755 0 1.491.078 2.207.212a8.04 8.04 0 0 0-.207 1.788 7.998 7.998 0 0 0 7.998 7.999 7.99 7.99 0 0 0 1.789-.208c.133.717.211 1.453.211 2.208a11.952 11.952 0 0 1-3.179 8.116zm-37.816 2.883c0 6.627 5.371 11.998 11.998 11.998h15.998a8 8 0 0 0 0-15.998c-1.6 0-3.083.482-4.334 1.291-1.231-5.316-5.973-9.29-11.664-9.29-6.627 0-11.998 5.372-11.998 11.999zm19.549-14.096h0zm7.659-4.695c-2.9.664-5.175 2.91-5.925 5.775a16.08 16.08 0 0 1 4.68 5.22c.664-.113 1.337-.205 2.033-.205 2.618 0 5.033.85 7.005 2.271a7.993 7.993 0 0 0 1.786-3.482 11.997 11.997 0 0 1-9.579-9.579z"/>'
  }
})
